import { Badge, Box } from 'dash-ui';
import { useTranslation } from 'react-i18next';

import { IBadgePropertyStatusChange } from './BadgePropertyStatusChange.interfaces';
import { BADGE_TO_STATUS_COLOR_MAP } from './BadgePropertyStatusChange.constants';

function BadgePropertyStatusChange({
  currentStatus,
}: IBadgePropertyStatusChange) {
  const { t } = useTranslation('common', { keyPrefix: 'labels' });

  return (
    <Box w={114}>
      <Badge
        h={32}
        square
        type={BADGE_TO_STATUS_COLOR_MAP[currentStatus]}
        title={t(currentStatus.toLowerCase())}
      />
    </Box>
  );
}

export default BadgePropertyStatusChange;
